import React  from 'react';

const style = {
    "font-size": '50px',
    "font-family": "'Courier New', Courier",
    "text-align": 'center'
}

const Title = () => {
    return <h1 style={style}> Jazz Giants </h1>
}

export default Title



// WEBPACK FOOTER //
// ./src/App/Center/Element/Title.js